import { defineMessages } from 'react-intl';

export default defineMessages({
  login: {
    id: 'Log in',
    defaultMessage: 'Log in',
  },
  openNavigationMenu: {
    id: 'open navigation menu',
    defaultMessage: 'open navigation menu',
  },
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchTermLabel: {
    id: 'Search term',
    defaultMessage: 'Search term',
  },
  whatAreYouLookingFor: {
    id: 'What are you looking for?',
    defaultMessage: 'What are you looking for?',
  },
  openSearchLabel: {
    id: 'open search',
    defaultMessage: 'open search',
  },
  closeSearchLabel: {
    id: 'close search',
    defaultMessage: 'close search',
  },
  searchSubmitLabel: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  servicesAndApps: {
    id: 'Services and apps',
    defaultMessage: 'SERVICES AND APPS',
  },
  didYouMean: {
    id: 'Did you mean?',
    defaultMessage: 'DID YOU MEAN?',
  },
  searchHistory: {
    id: 'Search history',
    defaultMessage: 'SEARCH HISTORY',
  },
});
